import { render, staticRenderFns } from "./CreateProjectAssistant.vue?vue&type=template&id=2fa44064&scoped=true&lang=pug&"
import script from "./CreateProjectAssistant.vue?vue&type=script&lang=ts&"
export * from "./CreateProjectAssistant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa44064",
  null
  
)

export default component.exports